import CorporateInvoiceItemResource from "./corporateInvoiceItem.resource";

const corporateInvoiceItemModule = angular
  .module("app.resources.corporateInvoiceItem", [])
  .service("CorporateInvoiceItem", CorporateInvoiceItemResource);

export default corporateInvoiceItemModule;



// WEBPACK FOOTER //
// ./src/resources/corporateInvoiceItem/corporateInvoiceItem.module.js